export const formSx = {
  formDialogLarge: {
    '& .MuiDialog-paperScrollPaper': {
      flex: '1 0 80%',
      maxWidth: '850px',
    },
  },
  formDialog: {
    '& .MuiDialog-paperScrollPaper': {
      flex: '1 0 80%',
      maxWidth: '550px',
    },
  },
  formDialogSmall: {
    '& .MuiDialog-paperScrollPaper': {
      flex: '1 0 80%',
      maxWidth: '500px',
    },
  },
  formHeading: {
    paddingBottom: 0,
    mx: -2,
    mt: -6,

    '&>.MuiTypography-h2': {
      flex: 1,
    },
  },
  formContainer: {
    maxWidth: '952px',
    width: '100%',
    margin: 'auto',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  formFieldsContainer: {
    width: '100%',
    mt: 4,
    backgroundColor: 'rgb(255, 255, 255)',
    p: '24px',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
  },
  formContainerMobile: {
    width: 'unset',
  },
  form: {
    '& .MuiCardContent-root': {
      p: 0,
    },
  },
};
